import React, { ReactElement } from "react";
import CategoryItem from "./category-item";
import { GQLCategories, GQLUrls } from "@gql/types/gql";
import styles from "./style.module.scss";
import { resolveURL } from "@lib/sharedUtils";
import { useQuery } from "@tanstack/react-query";
import { ICategoriesPageProp } from "@genericTypes/sharedTypes";

export default function Accordion({
    items,
    className,
}: {
    items: (GQLCategories | null)[] | null | undefined;
    className?: string;
}): ReactElement {
    const { data: pageProps } = useQuery<ICategoriesPageProp, Error>({
        queryKey: ["categoriesPageProps"],
    });

    const { domainOffers } = pageProps ?? {};

    const itemsList = items?.filter((item) => {
        if (
            domainOffers &&
            domainOffers.length &&
            domainOffers?.find((offer) => offer?.categoryId === item?.id)
                ?.offers.length
        ) {
            return item;
        }
    });

    return (
        <div className={styles.items}>
            {itemsList?.map(
                (item) =>
                    item && (
                        <div className={styles.item} key={item.id}>
                            <CategoryItem
                                key={item.id}
                                item={item}
                                className={className}
                                url={resolveURL(item?.url as GQLUrls)}
                            />
                        </div>
                    ),
            )}
        </div>
    );
}
